export const categories = ['All', 'Website delivery'];

// Restored from the previous Nalexus portfolio and its matching project-cover archive.
// Outcome claims and placeholder concepts are intentionally excluded.
export const allProjects = [
  ['JT Empresario', '2-JT-Empresario.png'],
  ['JT Sportsfest', '3-JT-portsfest.png'],
  ['JTMUN', '4-JTMUN.png'],
  ['Model Constructions', '5-Model-Constructions.png'],
  ['Websitech Community', '6-Websitech-Community.png'],
  ['Nalexus Technologies — previous edition', '8-Nalexus-Technologies-Old.png'],
  ['Carboxyl Chem', '11-Carboxyl-Chem.png'],
  ['Anzway Academy', '12-Anzway-Academy.png'],
  ['Code Academy', '13-Code-Academy.png'],
  ['DerminCare — dark edition', '14-DerminCare-Dark.png'],
  ['Model Constructions — new edition', '15-Model-Constructions-New.png'],
  ['Upskill Consultants', '16-Upskill-Co.png'],
  ['EngZone Engineering Services', '17-EngZone.png'],
  ['ManyFlow AI', '18-ManyFlow-AI.png'],
  ['I Visit North', '19-I-Visit-North.png'],
  ['Al Jilan Industries', '21-Al-Jilan.png'],
  ['BelleFemme', '22-BelleFemme.png'],
  ['DerminCare — light edition', '23-DerminCare-Light.png'],
  ['Serendipity Ventures', '24-Serendipity.png'],
  ['ACE Consultancy', '25-ACE-Consultancy.png'],
  ['DeThunder Fans', '26-DeThunder-Fans.png'],
  ['RealFight Project', '27-RealFight-Project.png'],
  ['UCL Sportsfest', '28-UCL-Sportsfest.png'],
  ['Jism us Saleem NGO', '29-Jism us-Saleem-NGO.png'],
].map(([title, file], index) => ({
  id: index + 1,
  title,
  category: 'Website delivery',
  image: `/assets/img/project-covers/${file}`,
}));
